import { createFileRoute } from '@tanstack/react-router';
import { requireOrgAdminBeforeLoad } from '../../../lib/org-admin-guard';

export const Route = createFileRoute('/_authenticated/company/constitution')({
  beforeLoad: requireOrgAdminBeforeLoad
}).lazy(() => import('./constitution.lazy').then((d) => d.Route));
